import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a9295c1a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9295c1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xinyushan/sdYuShan/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9295c1a')) {
      api.createRecord('a9295c1a', component.options)
    } else {
      api.reload('a9295c1a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a9295c1a&scoped=true&", function () {
      api.rerender('a9295c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/order/orderRefund/index.vue"
export default component.exports